// @ts-ignore

import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { Props_HeaderPage } from "@/types/type/propsTypes";
import { routes } from "@/routes/list";
import {HeaderWithBackButtonDefault} from "@UI/New/HeaderWithBackButton";
import Button from "@UI/New/Button";
import s from './style.module.css';
import classNames from "classnames";

const HeaderPage = (props: Props_HeaderPage) => {
  const pathnames = useLocation()
    .pathname.split("/")
    .filter((el: any) => el);
  const path = `/${pathnames.slice(0, pathnames.length).join("/")}`;
  const name = routes.find((el) => el.path === path)?.label;
  const title = (props?.title ? props.title : name) as string;
  const { loading, addNews } = props;

  return (
    <header className={classNames('page-header', s.headerPage)}>
        <HeaderWithBackButtonDefault
            link="/"
            className={undefined}
            title={title}
        />

        {addNews && <Button disabled={loading} onClick={addNews}>Добавить новость</Button>}
    </header>
  );
};

export default HeaderPage;
